<template>
  <div
    :style="{height: offsetHeight + 'px'}"
    class="cancel-progress-box">
    <h3>
      <span>{{'取消进度'|lang}}</span>
      <a @click="close" class="close" href="javascript:;">&times;</a>
    </h3>
    <cd-loading class="cancel-content-box" :isLoading="isLoading">
      <p class="apply-time">
        <span>{{'申请时间'|lang}}: </span>
        <span>{{orderRefund.createTime}}</span>
        <!-- <span>时间</span> -->
      </p>
      <p  class="apply-result">
        <span>{{'审核情况'|lang}}: </span>
        <span>{{orderRefund.statusName}}</span>
        <!-- <span>审核情况</span> -->
      </p>

      <div v-if="orderRefund.status === 1" class="cancel-apply">
        <cd-button @click.native="repeal">{{'撤销申请'|lang}}</cd-button>
      </div>

      <div v-else class="applied-txt">
        <p>
          <span>{{'审核时间'|lang}}: </span>
          <span>{{orderRefund.updateTime}}</span>
          <!-- <span>审核时间</span> -->
        </p>
        <p>
          <span>{{'商家拒绝原因'|lang}}: </span>
          <span>{{orderRefund.refuseReason}}</span>
          <!-- <span>拒绝原因</span> -->
        </p>
      </div>

      <div class="cancel-tips">
        <p>{{'applyAgain'|lang}}</p>
        <p>
          <span>{{'商家电话'|lang}}: </span>
          <span class="highlight">{{order.storePhone}}</span>
        </p>
      </div>
    </cd-loading>

  </div>
</template>

<script>
export default {
  name: 'cancel-progress',
  props: ['order', 'offsetHeight'],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    // 撤销申请
    repeal() {
      if (!this.isLoading) {
        this.isLoading = true;
        const content = `
          <p style="font-size:14px;margin:10px auto 20px;">是否撤销该次取消订单的申请?</p>
          <p style="font-size:12px;">*进行撤销申请后，将无法再次从线上对该张订单进行取消申请</p>
        `;
        this.$Modal.info({
          content,
          onOk: () => {
            // todo联调接口
            const { orderId } = this.order;
            this.$service.get('addVerifyCancelOrder', {
              orderId,
              cancelNote: '撤销申请',
              status: 2,
            })
              .then(() => {
                this.$Modal.info({
                  content: '取消订单申请已撤销',
                  onOk: () => {
                    this.isLoading = false;
                    this.close(true);
                  },
                });
              })
              .catch(() => {
                this.isLoading = false;
              });
          },
          onCancel() {
            this.isLoading = false;
          },
        });
      }
    },
    close(reload = false) {
      this.$emit('close', reload);
    },
  },
  created() {

  },
  computed: {
    orderRefund() {
      return JSON.parse(JSON.stringify(this.order.orderRefund || {}));
    },
  },
};
</script>

<style lang="sass" scoped>
.cancel-progress-box
  position: absolute
  top: 0px
  left: 0px
  width: 502px
  overflow: hidden
  padding-right: 10px
  background-color: #fff
  z-index: 10
  h3
    text-align: left
    border-bottom: 1px solid #e0e0e0
    font-size: 16px
    margin-left: 10px
    padding-left: 10px
    position: relative
    line-height: 48px
    span, a
      display: inline-block
    .close
      position: absolute
      top: 5px
      right: 5px
      width: 21px
      height: 21px
      font-size: 24px
      font-weight: 700
      line-height: 1
      color: #fc8b00
      text-shadow: 0 1px 0 #fff
      text-align: right
      margin: 8px 0 18px 0
      font-style: normal
      cursor: pointer

.cancel-content-box
  padding: 20px
  p
    line-height: 36px
    color: #5b5b5b
    font-size: 14px
  .cancel-apply
    margin:
      top: 24px
  .cancel-tips
    border-top: 1px solid #f3f3f3
    margin-top: 12px
    padding-top: 12px
    .highlight
      color: #ff5339
</style>
